import type { AnchorHTMLAttributes } from "react";
import { schedulePrintUrl, type SchedulePrintRequest } from "./schedulePrint";
import "../../../../../components/Button.css";
import "./PrintScheduleLink.css";

interface PrintScheduleLinkProps
  extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href" | "target" | "rel"> {
  request: SchedulePrintRequest;
}

/**
 * Opens the printable schedule in a new tab, carrying the filters on screen.
 *
 * A link styled as a secondary button rather than a button calling `window.open`: it is a real
 * navigation, so a coach can also middle-click it or copy it, and a new tab keeps their place on
 * the schedule (the month, an open panel) while they print.
 */
export const PrintScheduleLink = ({
  request,
  className = "",
  children = "Print / Save as PDF",
  ...props
}: PrintScheduleLinkProps) => (
  <a
    href={schedulePrintUrl(request)}
    target="_blank"
    rel="noopener noreferrer"
    className={["btn", "btn--secondary", "print-schedule-link", className].filter(Boolean).join(" ")}
    {...props}
  >
    {children}
    <span className="print-schedule-link__new-tab"> (opens in a new tab)</span>
  </a>
);
